import React from 'react';
import { X } from 'lucide-react';

interface LightboxProps {
  mediaUrl: string | null;
  onClose: () => void;
}

export const Lightbox: React.FC<LightboxProps> = ({ mediaUrl, onClose }) => {
  if (!mediaUrl) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 200,
        background: 'rgba(0, 0, 0, 0.9)',
        backdropFilter: 'blur(12px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
      }}
    >
      <button
        onClick={onClose}
        style={{
          position: 'absolute',
          top: '24px',
          right: '24px',
          color: '#ffffff',
          background: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '50%',
          padding: '10px',
        }}
      >
        <X size={24} />
      </button>

      <img
        src={mediaUrl}
        alt="Full screen media"
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: '90vw',
          maxHeight: '90vh',
          objectFit: 'contain',
          borderRadius: '12px',
          boxShadow: '0 20px 50px rgba(0,0,0,0.8)',
        }}
      />
    </div>
  );
};

